import { Link } from 'react-router-dom';

interface SettingsBreadcrumbProps {
  label: string;
  icon: string;
}

export default function SettingsBreadcrumb({ label, icon }: SettingsBreadcrumbProps) {
  return (
    <nav className="flex items-center gap-2 text-sm flex-wrap" aria-label="Ruta de navegación">
      <Link
        to="/settings"
        className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3 py-1.5 font-medium text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition cursor-pointer"
      >
        <i className="ri-settings-3-line" />
        Configuración
      </Link>
      <i className="ri-arrow-right-s-line text-foreground-400" />
      <span className="inline-flex items-center gap-1.5 rounded-md border border-primary-200 bg-primary-50 px-3 py-1.5 font-semibold text-primary-700">
        <i className={icon} />
        {label}
      </span>
    </nav>
  );
}